function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #e3f5fe !important;\n      }\n\n      .cls-1 {\n        opacity: 0.3;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        filter: url(#filter);\n      }\n\n      .cls-4 {\n        font-size: 16px;\n        fill: #083d77 !important;\n        text-anchor: middle;\n        font-family: Montserrat;\n        font-weight: 400;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 0,
  y: 0,
  width: 84,
  height: 84,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  result: "offset",
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 4.583
}), /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodOpacity: 0.18
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_2",
  "data-name": "Elipsa 1 kopia 2",
  className: "cls-1",
  cx: 83.25,
  cy: 88.125,
  r: 76.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_3",
  "data-name": "Elipsa 1 kopia 3",
  className: "cls-2",
  cx: 83.25,
  cy: 88.125,
  r: 55.84
});

var _ref5 = /*#__PURE__*/React.createElement("image", {
  id: "stack-of-presentation-cards",
  x: 52,
  y: 64,
  width: 65,
  height: 54,
  xlinkHref: "data:img/png;base64,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"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_3",
  "data-name": "Elipsa 3",
  className: "cls-3",
  cx: 41.25,
  cy: 41.295,
  r: 21.25
});

var _ref7 = /*#__PURE__*/React.createElement("text", {
  id: "_3",
  "data-name": 3,
  className: "cls-4",
  x: 41,
  y: 46.501
}, "3");

var SvgKrok3 = function SvgKrok3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupa_12",
    "data-name": "Grupa 12",
    width: 159.75,
    height: 164.78,
    viewBox: "0 0 159.75 164.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKrok3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/krok3.6bb5c10f.svg";
export { ForwardRef as ReactComponent };